import { Component } from '@angular/core';
import { UiSpinnerComponent } from '@akmf/ngx-ui-lib';
import { AsyncPipe } from '@angular/common';
import { Observable } from 'rxjs';
import { loaderSubject } from '@features/loader/loader.service';

@Component({
    selector: 'app-global-loader',
    template: `
    @if ((loaderSubject | async)?.loading) {
      <div class="loader-overlay">
        <app-ui-spinner [message]="(loaderSubject | async)?.message ?? ''"></app-ui-spinner>
      </div>
    }
  `,
    styles: [
        `
      .loader-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 10;
      }

      app-ui-spinner {
        transform: scale(2); /* powiększenie spinnera */
      }
    `,
    ],
    imports: [UiSpinnerComponent, AsyncPipe]
})
export class GlobalLoaderComponent {
  public loaderSubject: Observable<{
    loading: boolean;
    message?: string | undefined;
  }> = loaderSubject.asObservable();
}
